import React, { useEffect, useState } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import NavbarWrapper from "../components/layout/Navbar/NavbarWrapper";
import FooterWrapper from "../components/layout/Footer/FooterWrapper";
import AppRoutes from "./routes";
import ScrollTopButton from "../components/ui/ScrollTopButton/ScrollTopButton";
import { ThemeProvider } from "../context/ThemeContext";
import { smoothScrollToTop } from "../utils/smoothScroll";
import Preloader from "../components/ui/Preloader/Preloader";
import { AnimatePresence, motion } from "framer-motion";
import SpotlightOverlay from "../components/ui/SpotlightOverlay/SpotlightOverlay";

// ✅ Smooth scroll on route change
// src/app/App.tsx mein ScrollToTop component mein
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Instant scroll to top on route change
  }, [pathname]);

  return null;
}

function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div
      className="flex flex-col min-h-screen relative"
      style={{ background: "var(--bg)" }}
    >
      <NavbarWrapper />
      <main className="flex-1">{children}</main>
      <FooterWrapper />
      <ScrollTopButton />
    </div>
  );
}

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <ScrollToTop /> {/* ✅ now smooth */}
        <Preloader />
        <Layout>
          <AppRoutes />
        </Layout>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
